var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-tasks-provider',{staticClass:"g-h-full",scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var step = ref.step;
    var patchStep = ref.patchStep;
    var goNextStep = ref.goNextStep;
    var goPreviousStep = ref.goPreviousStep;
    var isPreview = ref.isPreview;
    var isLoading = ref.isLoading;
    var isCompletingBrief = ref.isCompletingBrief;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var hideContentApprovalOnboarding = ref.hideContentApprovalOnboarding;
    var context = ref.context;
return [_c('activation-brief-tasks-view',{attrs:{"brief":brief,"contact":contact,"step":step,"is-loading":isLoading,"is-completing-brief":isCompletingBrief,"errors":errors,"error-message":errorMessage,"context":context},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchStep,"hide-content-approval-onboarding":hideContentApprovalOnboarding}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }